module.exports = __webpack_public_path__ + "static/media/rss.edede9c5.svg";